module.exports = __webpack_public_path__ + "static/media/rogue_logo.cd6af2b3.png";